import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { useAccesControl } from '@/hooks/useAccessControl';
import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { useRoutepaths } from '@/router/hooks/useRoutePaths';
import { AllUsersTable } from '@/features/user/components/allUsers/AllUsersTable';
import { Page } from '@/ui-kit/templates/Page';

export const AllUsers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const PathRoute = useRoutepaths();
  const { settings } = useDashboardConfig();
  const { hasAccessToFeature } = useAccesControl();

  const canCreateUser = useMemo(
    () => hasAccessToFeature(featuresSlugs.CREATE_USER) && settings.screens.includes('createUser'),
    [hasAccessToFeature, settings.screens],
  );

  return (
    <Page
      title={t('layout.sidebar.links.users')}
      actions={[
        ...(canCreateUser
          ? [
              {
                id: 'btn-create-user',
                label: t('pages.dashboard.users.actions.createUser'),
                onClick: () => navigate(generatePath(PathRoute.app.root, { '*': PathRoute.app.createUser })),
                iconPosition: 'left',
                icon: 'add',
              } as const,
            ]
          : []),
      ]}
    >
      <AllUsersTable />
    </Page>
  );
};
